var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paginationDoc"},[_c('div',{staticClass:"paginationDoc_wrapper"}),_c('pagination',{attrs:{"max-page":_vm.getMaxPage,"selected-page":_vm.currentPage},on:{"change-page":_vm.changePage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }